<template>
  <b-row>
    <b-col cols="12">
      <hr>
    </b-col>
    <b-col cols="12" md="10">
      <b-form-group :label="'attracted_invoice' | translate('global')">
        <treeselect  value-format="object"
                     :placeholder=" 'select_attracted_invoice' | translate('global') "
                    :options="invoicesOptions" v-model="selectedInvoice"/>
      </b-form-group>
    </b-col>
    <b-col cols="12" md="2" class="mt-md-29">
      <SendToBookkeeper :isDisabled="isButtonDisabled"
                        :id="selectedInvoice ? selectedInvoice.id : null"/>
    </b-col>
    <b-col v-if="tableItems.length" cols="12">
      <b-card class="mt-3">
        <b-row>
          <b-col cols="6">
            <h4>{{ 'invoice' | translate('global') }}: {{ invoiceInfo.number }}</h4>
          </b-col>
        </b-row>
        <blockquote class="card-blockquote mt-2">
          <div class="table-responsive">
            <table class="table table-sm center">
              <thead>
              <tr>
                <th class="no-border-top">{{ 'supplier' | translate('global') }}</th>
                <th class="no-border-top">{{ 'vat_group' | translate('global') }}</th>
                <th class="no-border-top">{{ 'invoice_issue_at' | translate('global') }}</th>
                <th class="no-border-top">{{ 'order_payment_term' | translate('global') }}</th>
                <th class="no-border-top">{{ 'status' | translate('global')}}</th>
                <th class="no-border-top">{{ 'structure' | translate('global')}}</th>
                <th class="no-border-top">{{ 'sum' | translate('global') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="border-r-3">{{ invoiceInfo['supplier'] }}</td>
                <td class="border-r-3">{{ invoiceInfo['vat_group'] }}</td>
                <td class="border-r-3">{{ invoiceInfo['issueAt'] | formatDate }}</td>
                <td class="border-r-3">{{ invoiceInfo['paymentTerm'] | formatDate }}</td>
                <td class="border-r-3">{{ invoiceInfo['status'] | translate('statuses') }}</td>
                <td class="border-r-3">
                  <span v-for="item in invoiceInfo['structure']" :key="item.id">
                       {{ item.name }}; 
                  </span>
                  </td>
                <td class="border-r-3">{{ invoiceInfo['sum'] }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </blockquote>

        <b-table class="table-sm text-center mt-5 mb-3"
                 responsive striped :fields="tableFields" :items="tableItems">
          <template v-slot:options="row">
            <router-link v-if="Number(row.item.orderId) !== Number($route.params.id)"
              target="_blank" :to="{ name: 'OrderUpdate', params:{ id: row.item.orderId }}">
              <i class="fa fa-share-square-o fa-lg fa-success"/>
            </router-link>
          </template>
          <template v-slot:bottom-row="row" >
            <td colspan="1" class="border-top-black"><strong>{{ 'total_sum' | translate('global')}}</strong></td>
            <td colspan="1" class="border-top-black"></td>
            <td colspan="1" class="border-top-black"><strong>{{ itemsTotalSum }}</strong></td>
            <td colspan="1" class="border-top-black"></td>
          </template>
        </b-table>

        <b-card-footer>
          <b-row>
            <b-col cols="12" md="12">
              <div class="pull-right">
                <FactAndInvoiceApprove :isDisabled="isFactAndInvoiceApproveDisabled"
                                       :id="invoiceInfo['id']"/>
                <FactAndInvoiceDecline :isDisabled="isFactAndInvoiceDeclineDisabled"
                                       :id="invoiceInfo['id']"/>
              </div>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import statuses from '@/store/statuses';
import forEach from 'lodash.foreach';
import VuexTypes from '@/store/types/index';
import TreeselectMixin from '@/mixins/TreeselectMixin';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import SendToBookkeeper from './SendToBookkeeper.vue';
import FactAndInvoiceApprove from './FactAndInvoiceApprove';
import FactAndInvoiceDecline from './FactAndInvoiceDecline';

const OrdersTypes = VuexTypes.orders;
export default {
  mounted() {},
  props: {
    data: {
      type: Array,
    }
  },
  mixins: [TreeselectMixin],
  data() {
    return {
      invoicesOptions: [],
      selectedInvoice: null,
      tableItems: [],
      tableFields: [
        { key: 'title', label: this.$t('title', 'global') },
        { key: 'amount', label: this.$t('amount', 'global') },
        { key: 'sum', label: this.$t('sum', 'global') },
        { key: 'options', label: '' },
      ],
      invoiceInfo: {
        number: '',
        supplier: '',
        vat_group: '',
        issueAt: '',
        paymentTerm: '',
        sum: '',
        status: '',
        structure: '',
      },
      itemsTotalSum: 0,
      isButtonDisabled: true,
      isFactAndInvoiceApproveDisabled: true,
      isFactAndInvoiceDeclineDisabled: true,
    };
  },
  components: { Treeselect, SendToBookkeeper, FactAndInvoiceApprove, FactAndInvoiceDecline },
  computed: {
    ...mapGetters('Orders', [
      'orderFactsAndInvoicesList',
    ]),
  },
  watch: {
    data: {
      immediate: true,
      handler: function () {
        this.fillInvoiceOptions();
      },
      deep: true
    },
    selectedInvoice: {
      immediate: true,
      handler: function () {
        if (this.selectedInvoice) {
          const result = [];
          let totalSum = 0;
          forEach(this.selectedInvoice.data.items, (item) => {
            result.push({
              title: item['product']['full_name'],
              amount: item['fact_quantity'],
              sum: item['total_fact'],
              orderId: item['order']['id']
            });
            totalSum += Number(item['total_fact']);
          });
          this.tableItems = result;
          this.itemsTotalSum = totalSum.toFixed(2);

          this.invoiceInfo = {
            id: this.selectedInvoice.data['id'],
            number: this.selectedInvoice.data['number'],
            supplier: this.selectedInvoice.data['supplier'] ? this.selectedInvoice.data['supplier']['name'] : null,
            vat_group: this.selectedInvoice.data['supplier']
              ? this.selectedInvoice.data['supplier']['suppliers_taxes_classifier']
                ? this.selectedInvoice.data['supplier']['suppliers_taxes_classifier']['name'] : '-'
              : '-',
            issueAt: this.selectedInvoice.data['issue_at'],
            paymentTerm: this.selectedInvoice.data['paymentTermsClassifier']
              ? this.selectedInvoice.data['paymentTermsClassifier']['name'] : null,
            sum: this.selectedInvoice.data['sum'],
            status: this.$t(this.selectedInvoice.data['status'], 'statuses'),
            structure: this.selectedInvoice.data['structures'] ? this.selectedInvoice.data['structures'] : [],
          };
          this.isButtonDisabled = !this.selectedInvoice.data.actions['open_invoice_for_payment_approve'];
          this.isFactAndInvoiceApproveDisabled = !this.selectedInvoice.data.actions['approve_invoice_review'];
          this.isFactAndInvoiceDeclineDisabled = !this.selectedInvoice.data.actions['decline_invoice_review'];
        } else {
          this.tableItems = [];
          this.isButtonDisabled = true;
          this.isFactAndInvoiceApproveDisabled = true;
          this.isFactAndInvoiceDeclineDisabled = true;
        }
      },
      deep: true
    },
  },
  methods: {
    fillInvoiceOptions() {
      if (this.data.length < 2) {
        this.selectedInvoice = {
          id: this.data[0]['id'],
          label: this.data[0]['number'],
          data: this.data[0]
        };
      }
      const result = [];
      forEach(this.data, (item) => {
        result.push({
          id: item['id'],
          label: item['number'],
          data: item,
        });
      });
      this.invoicesOptions = result;
    },
  }
};

</script>

<style scoped>
  .border-top-black {
    border-top: 2px solid #c8ced3 !important;
  }
</style>
